var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M937.387 488.107L772.267 372.48c-12.8-9.387-30.294-6.827-40.107 5.547-3.84 4.693-5.547 10.666-5.547 17.066v233.814c0 22.613 25.6 36.693 45.654 22.613l165.546-115.627c14.08-14.08 14.08-36.693-0.426-47.786z m-23.04-274.774H129.28c-18.773 0-34.133-15.36-34.133-34.133s15.36-34.133 34.133-34.133h785.067c18.773 0 34.133 15.36 34.133 34.133s-14.933 34.133-34.133 34.133z m0 665.6H129.28c-18.773 0-34.133-15.36-34.133-34.133s15.36-34.133 34.133-34.133h785.067c18.773 0 34.133 15.36 34.133 34.133s-14.933 34.133-34.133 34.133zM624.213 435.2H129.28c-18.773 0-34.133-15.36-34.133-34.133s15.36-34.134 34.133-34.134h494.933c18.774 0 34.134 15.36 34.134 34.134S643.413 435.2 624.213 435.2z m0.427 221.867H129.28c-18.773 0-34.133-15.36-34.133-34.134s15.36-34.133 34.133-34.133h495.36c18.773 0 34.133 15.36 34.133 34.133v0.427c-0.426 18.347-15.36 33.707-34.133 33.707z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.841db22ac47758c6f6ccd09e76749e6a.svg";
export { ForwardRef as ReactComponent };